<fa-icon [icon]="icon"
         (click)="open()"
         [popover]="popTemplate" triggers="" containerClass="shadow-sm" [outsideClick]="true" #popover="bs-popover">
</fa-icon>

<ng-template #popTemplate>
  <fa-icon [icon]="icon" class="text-secondary float-right"></fa-icon>
  <div [innerHTML]="data"></div>
</ng-template>
